import React from 'react'

const NavFile = ({ title, fileUrl, className, linkClassName, hideNavigation }) => {
  const handleOnClick = () => hideNavigation()

  return (
    <li
      data-event-category='Mobile Menu'
      data-event-action='Select'
      data-event-label={title}
      className={className}
    >
      <a
        className={linkClassName}
        href={fileUrl}
        target='_blank'
        rel='noopener noreferrer'
        tabIndex='-1'
        onClick={handleOnClick}
      >
        {title}
      </a>
    </li>
  )
}

export default NavFile
